import { render, staticRenderFns } from "./Chatuser.vue?vue&type=template&id=24d8f369&scoped=true&"
import script from "./Chatuser.vue?vue&type=script&lang=js&"
export * from "./Chatuser.vue?vue&type=script&lang=js&"
import style0 from "./Chatuser.vue?vue&type=style&index=0&id=24d8f369&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8f369",
  null
  
)

export default component.exports